import { useEffect, useRef } from 'react';

/**
 * Keeps a <meta name="robots" content="noindex"> in the document while `active`.
 *
 * Each caller owns the element it created and removes only that one, so a page can
 * declare noindex from the top of the component (covering early returns such as a
 * sign-in prompt) without fighting another component that renders PageMeta later.
 */
export default function useNoindexMeta(active = true) {
  const elementRef = useRef(null);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    if (!active) {
      elementRef.current?.remove();
      elementRef.current = null;
      return undefined;
    }

    if (!elementRef.current) {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('content', 'noindex');
      meta.setAttribute('data-aprendos-noindex', 'true');
      document.head.appendChild(meta);
      elementRef.current = meta;
    }

    return () => {
      elementRef.current?.remove();
      elementRef.current = null;
    };
  }, [active]);
}
